// Customer status shown to staff: calculated by the server from completed
// visits (computedStatus: new, active, at_risk, inactive). VIP is a
// separate manual flag (isVip). See backend/services/customerStatusService.js.
export const CUSTOMER_STATUS_LABELS = {
  new: "New",
  active: "Active",
  at_risk: "At Risk",
  inactive: "Inactive",
};

export const customerStatusLabel = (status) =>
  CUSTOMER_STATUS_LABELS[status] || CUSTOMER_STATUS_LABELS.new;

// The same rule as backend/utils/vipStatus.js: an explicit isVip wins;
// before the migration, customerStatus "vip" still counts.
export const isVipCustomer = (customer) => {
  if (!customer) return false;
  if (typeof customer.isVip === "boolean") return customer.isVip;
  return customer.customerStatus === "vip";
};
